/* tslint:disable */

declare var Object: any;
export interface StorageChatInterface {
  "id"?: number;
}

export class StorageChat implements StorageChatInterface {
  "id": number;
  constructor(data?: StorageChatInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `StorageChat`.
   */
  public static getModelName() {
    return "StorageChat";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of StorageChat for dynamic purposes.
  **/
  public static factory(data: StorageChatInterface): StorageChat{
    return new StorageChat(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'StorageChat',
      plural: 'StorageChats',
      path: 'StorageChats',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/StorageChat.ts